import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useMemo, useCallback } from 'react';
import { propBool, propFunc, propStr } from '../../../helpers/custom-prop-types';
const SplitText = (props) => {
    const { className, convertLink, renderFunc, text, wrap } = props;
    const outputList = useMemo(() => {
        const fixText = text === null || text === undefined ? '' : text;
        return fixText.split('\n').map((row, index) => ({
            id: index,
            row,
        }));
    }, [text]);
    const render = useCallback((row) => {
        if (renderFunc) {
            return renderFunc(row);
        }
        return row;
    }, [renderFunc]);
    const Wrap = wrap || Fragment;
    const addProps = wrap ? { className } : {};
    return (_jsx(Wrap, Object.assign({}, addProps, { children: outputList.map(({ id, row }) => (_jsxs(Fragment, { children: [id > 0 && _jsx("br", {}), convertLink && row.match(/^(http|https):\/\//) ? (_jsx("a", Object.assign({ href: row, rel: 'noopener noreferrer', target: '_blank' }, { children: row }))) : (render(row, id))] }, id))) })));
};
SplitText.propTypes = {
    className: propStr(),
    convertLink: propBool(),
    renderFunc: propFunc(),
    text: propStr(),
    wrap: propStr(),
};
SplitText.defaultProps = {
    className: undefined,
    convertLink: true,
    renderFunc: undefined,
    text: '',
    wrap: '',
};
export default SplitText;
